import React, { useState, useEffect, useRef } from "react";

import SavedCardForm from "../billing/forms/settings-card/saved-card-form";
import SaveCardCheckbox from "./SaveCardCheckbox";
import StripeSplitForm from "../billing/stripe-split-form";

import {
    updateStripeFormData,
    setUpdatingCard,
    toggleSaveCard
} from "./actionCreators";

const PaymentInfoSection = ({
    state,
    dispatch,
    stripePublishableKey,
    clearErrorsWithReduxInStripeState
}) => {
    const [clearForm, setClearForm] = useState(0);
    const balanceNeverPurchased = useRef(true);

    useEffect(() => {
        /* when the user clicks "add more icons" after purchasing
        a balance, the `balancePurchased` state will go from `true` to `false`.  
        this state change is used as an indicator of when the page resets. 
        resetting the page includes presenting the user with an empty form, 
        but because we dont' have control over clearing Stripe Element inputs, 
        updating the value of `clearForm` will prompt rendering a new instance of
        `StripeSplitForm`, which has empty fields.*/
        if (state.balancePurchased) balanceNeverPurchased.current = false;

        if (!balanceNeverPurchased && !state.balancePurchased) {
            setClearForm(clearForm + 1);
        }
    }, [state.balancePurchased, clearForm]);

    const form = stripePublishableKey && (
        <StripeSplitForm
            key={clearForm}
            stripePublishableKey={stripePublishableKey}
            turnOffAutofocus
            disabled={state.processingRequest}
            handleComplete={(stripeObjectInstance, stripeTokenData) => {
                dispatch(
                    updateStripeFormData({
                        stripeObjectInstance,
                        stripeTokenData
                    })
                );
            }}
        />
    );

    const useSavedCardButton = (
        <button
            onClick={e => {
                e.preventDefault();
                clearErrorsWithReduxInStripeState();
                dispatch(setUpdatingCard({ updatingCard: false }));
            }}
        >
            Use saved card
        </button>
    );

    const updatePaymentInfoButton = (
        <button
            onClick={e => {
                e.preventDefault();
                dispatch(setUpdatingCard({ updatingCard: true }));
            }}
        >
            Update payment information
        </button>
    );

    const enteringCardInfo = state.updatingCard || !state.savedCreditCardInfo;
    const notUsingSavedCard = !state.savedCreditCardInfo || state.updatingCard;

    const changeFormButton = state.updatingCard
        ? useSavedCardButton
        : updatePaymentInfoButton;

    return (
        <fieldset>
            <header>
                <h3>Payment Information</h3>
                {state.savedCreditCardInfo && changeFormButton}
            </header>
            {enteringCardInfo ? (
                form
            ) : (
                <SavedCardForm card={state.savedCreditCardInfo} />
            )}
            <ol>
                <li>
                    {notUsingSavedCard && (
                        <SaveCardCheckbox
                            disabled={state.processingRequest}
                            checked={state.saveCardInputChecked}
                            onChange={() => dispatch(toggleSaveCard())}
                        />
                    )}
                </li>
            </ol>
        </fieldset>
    );
};

export default PaymentInfoSection;
